import { CgClose } from "react-icons/cg";
import { IoChevronDownOutline } from "react-icons/io5";
import { useContext, useMemo, useState } from "react";
import "./menudrawer.scss";
import { NavLink } from "react-router-dom";
import {
  navItems as navItemsConfig,
  hospitalServiceLinks,
} from "../../../../constants/navigation.js";
import WebInfoContext from "../../../../context/WebInfo/WebInfoContext.ts";
import { buildCategoryMenuColumns } from "../../../../utils/categoryMenu.js";

const MenuDrawer = ({ setShowMenu }) => {
  const [openItem, setOpenItem] = useState(null);
  const { categorys } = useContext(WebInfoContext);

  const toggleItem = (id) => {
    setOpenItem((prev) => (prev === id ? null : id));
  };

  const handleAction = (item) => {
    if (item.action === "scroll-footer") {
      document
        .getElementById("footer-container")
        ?.scrollIntoView({ behavior: "smooth", block: "nearest" });
      setShowMenu(false);
      return;
    }
    setShowMenu(false);
  };

  const categoryColumns = useMemo(
    () => buildCategoryMenuColumns(categorys),
    [categorys]
  );

  const navigationItems = useMemo(
    () =>
      navItemsConfig.map((item) =>
        item.id === "store" ? { ...item, columns: categoryColumns } : item
      ),
    [categoryColumns]
  );

  return (
    <div className="menus_drawer">
      <div className="drawer_header d-flex justify-content-between align-items-center mb-3">
        <span className="fw-bold">منوی سایت</span>
        <button
          className="icon-button"
          onClick={() => setShowMenu(false)}
          aria-label="بستن"
        >
          <CgClose />
        </button>
      </div>
      <div className="drawer_list">
        {navigationItems.map((item) => {
          if (item.type === "mega") {
            const isOpen = openItem === item.id;
            return (
              <div key={item.id} className="drawer_item">
                <button
                  className="drawer_trigger"
                  onClick={() => toggleItem(item.id)}
                >
                  <span>{item.label}</span>
                  <IoChevronDownOutline className={isOpen ? "rotate" : ""} />
                </button>
                <div className={`drawer_panel ${isOpen ? "open" : ""}`}>
                  {(item.columns ?? []).map((column) => (
                    <div key={column.id} className="panel_column">
                      <span className="panel_heading">{column.title}</span>
                      <ul>
                        {column.links.map((link) => (
                          <li key={link.path}>
                            <NavLink
                              to={link.path}
                              onClick={() => setShowMenu(false)}
                            >
                              {link.label}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            );
          }
          if (item.type === "dropdown") {
            const isOpen = openItem === item.id;
            return (
              <div key={item.id} className="drawer_item">
                <button
                  className="drawer_trigger"
                  onClick={() => toggleItem(item.id)}
                >
                  <span>{item.label}</span>
                  <IoChevronDownOutline className={isOpen ? "rotate" : ""} />
                </button>
                <div className={`drawer_panel ${isOpen ? "open" : ""}`}>
                  <ul>
                    {hospitalServiceLinks.map((link) => (
                      <li key={link.id}>
                        <NavLink to={link.path} onClick={() => setShowMenu(false)}>
                          {link.label}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          }
          return (
            <div key={item.id} className="drawer_item">
              {item.path ? (
                <NavLink
                  to={item.path}
                  className="drawer_link"
                  onClick={() => handleAction(item)}
                >
                  {item.label}
                </NavLink>
              ) : (
                <button
                  className="drawer_link text-start w-100 bg-transparent border-0"
                  onClick={() => handleAction(item)}
                >
                  {item.label}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MenuDrawer;
